// add to accessibe pixel
setTimeout(() => {
  document.querySelectorAll('img:not([alt]):not([role])').forEach(img => {
    if (img.width <= 1 && img.height <= 1) {
      img.setAttribute('role', 'none');
    }
  });
}, 1500);

// Ensure every ARIA button, link and menuitem has an accessible name.
document.addEventListener('DOMContentLoaded', function () {
  const logoLinks = document.querySelectorAll('[id^="Slide-logo_"] a[role="link"]');

  logoLinks.forEach(function (link) {
    if (link.getAttribute('aria-label')?.trim()) return;

    const img = link.querySelector('img');
    const svgTitle = link.querySelector('svg title');
    const textNode = (link.textContent || '').trim();

    let label = '';

    if (img && img.getAttribute('alt') && img.getAttribute('alt').trim()) {
      label = img.getAttribute('alt').trim();
    } else if (svgTitle && svgTitle.textContent.trim()) {
      label = svgTitle.textContent.trim();
    } else if (textNode) {
      label = textNode;
    } else {
      label = 'Company logo';
    }

    link.setAttribute('aria-label', label);
  });
});

// Ensure aria-hidden elements are not focusable nor contain focusable elements
document.addEventListener('DOMContentLoaded', function () {
  const hiddenFocusable = document.querySelectorAll('a[aria-hidden="true"]');

  hiddenFocusable.forEach(function (el) {
    // Remove from tab order
    el.setAttribute('tabindex', '-1');

    // Prevent keyboard focus via JS (extra safety)
    el.addEventListener('focus', function (e) {
      e.preventDefault();
      el.blur();
    });
  });
});
// Links must have discernible text, so add aria-labels to blog links based on their titles
// document.addEventListener('DOMContentLoaded', function () {
//   const link = document.querySelector('a.image-overlay__image-link[href="/blogs/headlines-that-matter"]');

//   if (link && !link.getAttribute('aria-label')) {
//     link.setAttribute('aria-label', 'Read Headlines That Matter');
//     link.setAttribute('title', 'Read Headlines That Matter');
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  // Select all anchor tags that are likely image-only links (no visible text)
  const linkedImages = document.querySelectorAll('a:has(img):not([aria-label]):not([aria-labelledby]):not([title])');

  linkedImages.forEach(link => {
    // Skip if the link already has visible text content
    const visibleText = link.textContent.trim();
    if (visibleText.length > 0) return;

    // Try to derive a label from the href
    const href = link.getAttribute('href') || '';
    const label = hrefToLabel(href);

    if (label) {
      link.setAttribute('aria-label', label);
      link.setAttribute('title', label);
    }
  });

  // Also catch "overlay" style links — full-coverage anchors with no img child
  // (like your .z-2.bottom-0 example — empty <a> stretched over a section)
  const overlayLinks = document.querySelectorAll(
    'a:not([aria-label]):not([aria-labelledby]):not([title])'
  );

  overlayLinks.forEach(link => {
    const visibleText = link.textContent.trim();
    if (visibleText.length > 0) return;

    const hasOnlyImages = [...link.querySelectorAll('*')].every(
      el => el.tagName === 'IMG' || el.tagName === 'PICTURE' || el.tagName === 'SOURCE'
    );

    // Only process links that are empty or contain only image elements
    const childCount = link.querySelectorAll('*').length;
    if (childCount > 0 && !hasOnlyImages) return;

    const href = link.getAttribute('href') || '';
    const label = hrefToLabel(href);

    if (label) {
      link.setAttribute('aria-label', label);
      link.setAttribute('title', label);
    }
  });
});

/**
 * Converts a URL path into a human-readable label.
 * e.g. "/collections/patriot-deals" → "Patriot Deals"
 *      "/blogs/headlines-that-matter" → "Headlines That Matter"
 */
function hrefToLabel(href) {
  try {
    // Handle absolute URLs too
    const path = href.startsWith('http') ? new URL(href).pathname : href;
    const segments = path.replace(/\/$/, '').split('/').filter(Boolean);
    if (segments.length === 0) return null;

    const lastSegment = segments[segments.length - 1];

    // Convert slug to title case
    const label = lastSegment
      .replace(/-/g, ' ')
      .replace(/\b\w/g, c => c.toUpperCase());

    // Optionally prefix with context from parent segment
    const prefix = segments.length > 1 ? segments[segments.length - 2] : null;
    const contextMap = {
      collections: 'Shop',
      blogs: 'Read',
      pages: 'View',
      products: 'View',
    };

    const verb = contextMap[prefix] ?? 'View';
    return `${verb} ${label}`;
  } catch {
    return null;
  }
}